module.exports = __webpack_public_path__ + "static/image-01-a@2x-91e0908320d5bf6010fde73e8da4cf7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/designmuseum/image-01-a@2x.jpg
// module id = 363
// module chunks = 3627797113349 20562973939449 33019919093843